import { authFetch, API_URL, clearAuthSession, getAuthHeaders } from "../../utils/auth";

const BASE = `${API_URL}/activity/`;

function buildHeaders(json = true) {
  const headers = {
    Accept: "application/json",
    ...getAuthHeaders(),
  };

  if (json) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
}

async function parseResponse(response) {
  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await response.json()
    : { detail: "The request could not be completed." };

  if (response.status === 401) {
    clearAuthSession();
  }

  if (!response.ok) {
    const error = new Error(data?.detail || data?.message || "Activity request failed.");
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

function query(filters = {}) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (key === "signal") return;
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value);
    }
  });

  return params.toString();
}

export async function fetchActivitySummary(filters = {}) {
  const q = query(filters);
  return parseResponse(await authFetch(`${BASE}summary/${q ? `?${q}` : ""}`, {
    headers: buildHeaders(false),
    signal: filters.signal,
  }));
}

export async function fetchActivities(filters = {}) {
  const q = query(filters);
  return parseResponse(await authFetch(`${BASE}${q ? `?${q}` : ""}`, {
    headers: buildHeaders(false),
    signal: filters.signal,
  }));
}

export async function fetchActivity(id, options = {}) {
  return parseResponse(await authFetch(`${BASE}${id}/`, {
    headers: buildHeaders(false),
    signal: options.signal,
  }));
}

export async function createManualActivity(payload) {
  return parseResponse(await authFetch(`${BASE}manual/`, {
    method: "POST",
    headers: buildHeaders(true),
    body: JSON.stringify(payload),
  }));
}